<template>
  <div class="checkin-page">
    <div class="checkin__top-bar">
      <span
        v-show="path.includes('course')"
        class="ic-arrow-left icon"
        @click="handleClickBackward"
      />
      {{ centerAccount.name }}
    </div>
    <div class="checkin-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      centerAccount: 'getCenterAccount'
    }),
    path() {
      return this.$route.path;
    },
    isLightGreyPlan() {
      return this.$store.getters.getIsLightGreyPlan;
    }
  },
  watch: {
    isLightGreyPlan: {
      immediate: true,
      handler: function(isAccessBlocked) {
        if (isAccessBlocked) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    }
  },
  created() {
    this.$store.dispatch('syncCenterAccount');
    this.$store.dispatch('syncPolicy');
    this.$store.dispatch('syncInstructors');
  },
  methods: {
    handleClickBackward() {
      this.$router.replace('/checkin').catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.checkin-page {
  background-color: #4a4a4a;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.press-animation {
  cursor: pointer;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-duration: 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0s;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  &:focus {
    outline: 0;
  }

  &:active {
    background-color: #c3c3c3;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
}

.checkin__top-bar {
  width: 100%;
  height: 60px;
  background-color: white;
  text-align: center;
  line-height: 60px;
  color: #202020;

  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.7px;
  position: relative;

  .ic-arrow-left {
    position: absolute;
    left: 13px;
    top: 13px;
    width: 35px;
    height: 35px;
    background-size: 35px;
    cursor: pointer;
  }

  @media screen and (max-height: 700px) {
    display: none;
  }
}

.checkin-description {
  font-size: 18px;
  line-height: 27px;
  font-weight: 500;
  letter-spacing: -0.5px;
  text-align: center;
  color: #9b9b9b;

  @media screen and (max-height: 1023px) {
    /**
       * Small Desktop or Tablet (768px < height < 1024px)
       */
    font-size: 15px;
    line-height: 20px;
  }

  @media screen and (max-height: 700px) {
    /**
       * Mobile (height < 768px)
       */
    font-size: 13px;
    line-height: 22px;
  }
}

.checkin-header {
  /**
     * Large Desktop (height > 1024px)
     */
  padding-top: 110px;
  padding-bottom: 60px;

  h1 {
    font-size: 35px;
    line-height: 50px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: -1px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 25px;
  }

  @media screen and (max-height: 1023px) {
    /**
       * Small Desktop or Tablet (768px < height < 1024px)
       */
    padding-top: 70px;
    padding-bottom: 40px;

    h1 {
      font-size: 25px;
      line-height: 35px;
      margin-bottom: 16px;
      letter-spacing: -1.5px;
    }

    div.description {
      font-size: 15px;
      line-height: 20px;
    }
  }

  @media screen and (max-height: 700px) {
    /**
       * Mobile (height < 768px)
       */
    padding-top: 25px;
    padding-bottom: 10px;

    h1 {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 10px;
    }

    div.description {
      font-size: 13px;
      line-height: 22px;
    }
  }
}

.checkin-container {
  margin: 0 auto;
  height: calc(100% - 60px);
  position: relative;

  .footer {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    height: 54px;
    line-height: 54px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
  }

  @media screen and (max-height: 700px) {
    height: 100%;
  }
}

.checkin-action-container {
  margin: 0 auto;
  width: 420px;

  @media screen and (max-height: 1023px) {
    /**
       * Small Desktop or Tablet (768px < height < 1024px)
       */
    width: 275px;
  }
}

div.checkin-box {
  min-height: 60px;
  border-radius: 12px;
  box-shadow: 0 2px 0 0 #d3d3d3;
  border: solid 1.5px #f0f0f0;
  background-color: #ffffff;
}

.checkin__child-course {
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;

  &:active {
    border: solid 1.5px #a2a2a2;
  }

  &:last-child {
    margin-bottom: 20px;
  }

  span {
    line-height: 29px;
    font-size: 20px;
    font-weight: 300;
    letter-spacing: -1px;
    color: #4a4a4a;
  }
  .contents-wrapper {
    width: calc(100% - 30px);

    .dialog-item__name {
      display: block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .dialog-item__contents {
      display: flex;
      flex-wrap: wrap;
      span:first-child {
        margin-right: 5px;
      }
    }
  }

  .right-arrow {
    margin: auto;
    width: 30px;
    height: 30px;
    background-image: url('/image/icon/arrowbox/arrow/misc/right.svg');
    background-repeat: no-repeat;
    background-size: contain;
  }

  @media screen and (max-height: 1023px) {
    padding: 15px;

    span {
      font-size: 14px;
      line-height: 20px;
    }

    .contents-wrapper {
      width: calc(100% - 20px);
    }

    .right-arrow {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
